import {
  BackofficeGetProductList,
  QueryStringSearch,
} from '@diamond/shared/types';
import { apiInstance } from '@diamond/shared/utils';
import cleanDeep from 'clean-deep';

export const getProducts = async (
  token: string,
  params: Readonly<QueryStringSearch>
) => {
  const url = '/backoffice/product/list';
  const { data } = await apiInstance(token).get<BackofficeGetProductList>(url, {
    params: cleanDeep(params),
  });
  return data;
};
